import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Landmark, KeyRound } from "lucide-react";

export default function OpenApiPanel() {
  const [st, setSt] = useState(null);
  const [token, setToken] = useState("");
  const load = () => api.get("/settings/openapi").then(r => setSt(r.data)).catch(() => null);
  useEffect(() => { load(); }, []);
  const save = async (t) => {
    try { await api.put("/settings/openapi", { token: t }); toast.success(t ? "Chiave OpenAPI.it salvata" : "Chiave rimossa"); setToken(""); load(); }
    catch { toast.error("Errore salvataggio"); }
  };
  return (
    <section className="space-y-3" data-testid="openapi-panel">
      <div>
        <h2 className="font-display text-lg font-semibold text-slate-900 flex items-center gap-2"><Landmark size={18} /> Registro Imprese (OpenAPI.it)</h2>
        <p className="text-sm text-slate-500">Senza chiave la compilazione automatica usa VIES (gratuito: ragione sociale e sede). Con la chiave OpenAPI.it recupera anche PEC, ATECO, attività e legale rappresentante. Crea il token su <a href="https://console.openapi.com" target="_blank" rel="noreferrer" className="text-blue-700 underline">console.openapi.com</a>.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-wrap items-center gap-3">
        <span className={`text-xs px-2 py-1 rounded-full font-semibold ${st?.configured ? "bg-emerald-100 text-emerald-800" : "bg-slate-100 text-slate-600"}`} data-testid="openapi-status">
          {st?.configured ? `Chiave configurata ${st.token_hint}` : "Solo VIES (nessuna chiave)"}
        </span>
        <input type="password" value={token} onChange={(e) => setToken(e.target.value)} placeholder="Incolla qui il token OpenAPI.it" data-testid="openapi-token"
          className="flex-1 min-w-[240px] px-3 py-2 border border-slate-300 rounded-lg font-mono text-sm" />
        <button onClick={() => save(token.trim())} disabled={!token.trim()} data-testid="openapi-save" className="inline-flex items-center gap-1 bg-slate-900 text-white px-3 py-2 rounded-lg text-sm disabled:opacity-50"><KeyRound size={14} /> Salva chiave</button>
        {st?.configured && <button onClick={() => save("")} className="text-sm text-red-600 hover:underline" data-testid="openapi-remove">Rimuovi</button>}
      </div>
    </section>
  );
}
